import { styled } from 'stitches.config'
import { FooterRoot } from 'components/Footer/Footer.styles'
import { Stack } from 'components/Stack'
import { VerticalSeparatorRoot } from 'components/VerticalSeparator/VerticalSeparator.styles'

export const TermsAndConditionsRoot = styled('div', {
  backgroundColor: '$secondary-100',

  '&': {
    [`${FooterRoot}`]: {
      borderTop: '12px solid transparent',
      borderBottom: 0,
      borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

      '@bp2': {
        borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
      },
    },
  },
})

export const Content = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',

  $$headerHeight: '80px',
  $$footerHeight: '373px',
  $$mobileFooterHeight: '498px',

  minHeight: 'calc(100vh - $$mobileFooterHeight)',

  '@bp2': {
    minHeight: 'calc(100vh - $$headerHeight - $$footerHeight)',
  },
})

export const Wrapper = styled('div', {
  width: '$max',
  padding: '$11 $3 $10',

  '& a': {
    color: '$primary-800',

    '&:hover': {
      color: '$primary-700',
    },

    '&:active': {
      color: '$primary-600',
    },
  },

  '@bp1': {
    paddingLeft: '$6',
    paddingRight: '$6',
  },

  '@bp2': {
    padding: '$11 $15',
    paddingTop: 'calc($$headerHeight + $7)',
  },
})

export const Introduction = styled('div', {
  display: 'flex',
  gap: '$8',

  '&': {
    [`${VerticalSeparatorRoot}`]: {
      display: 'none',
    },
  },

  '@bp2': {
    paddingLeft: '$6',

    '&': {
      [`${VerticalSeparatorRoot}`]: {
        display: 'block',
        height: 'auto',
      },
    },
  },
})

export const CollapsibleContentWrapper = styled('div', {
  paddingBottom: '$3',
})

export const Contact = styled(Stack, {
  '& a': {
    display: 'block',
    color: '$primary-500',

    '&:hover': {
      color: '$primary-400',
    },

    '&:active': {
      color: '$primary-600',
    },
  },
})
